var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "index-tab-permission" },
    [
      _c(
        "el-row",
        { attrs: { gutter: 10 } },
        [
          _c(
            "el-col",
            { attrs: { span: 12 } },
            [
              _c("el-alert", {
                staticClass: "d2-mb-10",
                attrs: { title: "d2-quill", type: "info", closable: false }
              }),
              _c("d2-quill", {
                model: {
                  value: _vm.value,
                  callback: function($$v) {
                    _vm.value = $$v
                  },
                  expression: "value"
                }
              })
            ],
            1
          ),
          _c(
            "el-col",
            { attrs: { span: 12 } },
            [
              _c("el-alert", {
                staticClass: "d2-mb-10",
                attrs: {
                  title: "v-model bing value",
                  type: "info",
                  closable: false
                }
              }),
              _c("el-input", {
                attrs: {
                  type: "textarea",
                  rows: 16,
                  value: _vm.value,
                  disabled: ""
                }
              })
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }